/**
 * TanStack Query hooks for `real-time-event-alerts-conversion-chargeback-fraud-cap-hit`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	realTimeEventAlertsConversionChargebackFraudCapHitQueryKeys,
	type CreateRealTimeEventAlertsConversionChargebackFraudCapHitBody,
	type ListRealTimeEventAlertsConversionChargebackFraudCapHitResponse,
	type RealTimeEventAlertsConversionChargebackFraudCapHitRow,
} from "./api";

export function useRealTimeEventAlertsConversionChargebackFraudCapHitList(): UseQueryResult<ListRealTimeEventAlertsConversionChargebackFraudCapHitResponse, Error> {
	return useQuery({
		queryKey: realTimeEventAlertsConversionChargebackFraudCapHitQueryKeys.list(),
		queryFn: list,
	});
}

export function useRealTimeEventAlertsConversionChargebackFraudCapHitCreate(): UseMutationResult<RealTimeEventAlertsConversionChargebackFraudCapHitRow, Error, CreateRealTimeEventAlertsConversionChargebackFraudCapHitBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeEventAlertsConversionChargebackFraudCapHitQueryKeys.all });
		},
	});
}

export function useRealTimeEventAlertsConversionChargebackFraudCapHitDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeEventAlertsConversionChargebackFraudCapHitQueryKeys.all });
		},
	});
}
